import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';
import { isProdRouteVisible, normalizeRoutePath } from '@/constants/prod-parity';

/** Redirects to /wallet when the route is not on ys142857.com prod. */
export function ProdRouteGuard({ path, children }: { path: string; children: ReactElement }) {
  if (!isProdRouteVisible(normalizeRoutePath(path))) {
    return <Navigate to="/wallet" replace />;
  }
  return children;
}
